export default __webpack_public_path__ + "static/media/Funny Prank.a97983ec.png";